import React from 'react';
import PropTypes from 'prop-types';
import AppConfiguration from './AppConfiguration';
import './AppConfigurations.scss';

const AutoRetailsApps = ['papyrus'];

function AppConfigurations(props) {
  return (
    <div className="app-configurations">
      {AutoRetailsApps.map(autoRetailApp => (
        <AppConfiguration appName={autoRetailApp} {...props} />
      ))}
    </div>
  );
}

AppConfigurations.propTypes = {
  actions: PropTypes.object,
  appConfigurations: PropTypes.object,
};

export default AppConfigurations;
